<template>
  <div class="stripe-guide-modal">
    <v-toolbar class="modal-toolbar" density="comfortable" flat>
      <div class="modal-bar">
        <v-btn icon variant="text" class="back-btn" aria-label="Back" @click="modal.close()">
          <v-icon>mdi-arrow-left</v-icon>
        </v-btn>
        <div class="modal-title">Stripe setup guide</div>
      </div>
    </v-toolbar>

    <v-card-text class="body py-6">
      <div class="section">
        <div class="section-title">Where to find your keys</div>
        <ol class="list">
          <li>Open your Stripe Dashboard.</li>
          <li>Go to <strong>Developers</strong> → <strong>API keys</strong>.</li>
          <li>Copy your <strong>Publishable key</strong> and <strong>Secret key</strong>.</li>
        </ol>
      </div>

      <div class="section">
        <div class="section-title">Webhook signing secret</div>
        <ol class="list">
          <li>In Stripe Dashboard, go to <strong>Developers</strong> → <strong>Webhooks</strong>.</li>
          <li>Select your endpoint (or create one).</li>
          <li>Reveal and copy the <strong>Signing secret</strong>.</li>
        </ol>
        <p class="note">
          If you already have a webhook secret saved, you can see it in the credentials step (read-only).
        </p>
      </div>
    </v-card-text>
  </div>
</template>

<script setup lang="ts">
import { useModalStore } from "@/shared/stores/modal";

const modal = useModalStore();
</script>

<style scoped>
.stripe-guide-modal {
  min-height: 100vh;
  background: #fff;
}

.modal-bar {
  width: 100%;
  display: grid;
  grid-template-columns: auto 1fr;
  align-items: center;
  gap: 10px;
}

.modal-title {
  font-size: 16px;
  font-weight: 800;
  color: #0f172a;
}

.body {
  max-width: 720px;
  margin: 0 auto;
}

.section {
  display: grid;
  gap: 10px;
  margin-bottom: 18px;
}

.section-title {
  font-size: 14px;
  font-weight: 800;
  color: #111827;
}

.list {
  margin: 0;
  padding-left: 18px;
  display: grid;
  gap: 6px;
  color: #374151;
  font-size: 14px;
  line-height: 1.5;
}

.note {
  margin: 0;
  color: #6b7280;
  font-size: 13px;
  line-height: 1.5;
}
</style>

